import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Switch } from '../../components/ui/switch';
import { Bell } from 'lucide-react';
import { toast } from 'sonner';
import { usePushNotifications } from '../../hooks/usePushNotifications';

export default function NotificationsTab() {
  const { supported, permission, isSubscribed, subscribe, unsubscribe, testPush } = usePushNotifications();
  const [testing, setTesting] = useState(false);

  const handleToggle = async () => {
    if (isSubscribed) {
      await unsubscribe();
      toast.success('Push notifications disabled');
    } else {
      const ok = await subscribe();
      if (ok) toast.success('Push notifications enabled!');
      else toast.error('Unable to enable push notifications. Check browser permissions.');
    }
  };

  const handleTest = async () => {
    setTesting(true);
    const ok = await testPush();
    setTesting(false);
    if (ok) toast.success('Test notification sent!');
    else toast.error('Failed to send test notification');
  };

  return (
    <Card className="bg-white border-gray-border">
      <CardHeader>
        <CardTitle className="flex items-center gap-2"><Bell className="h-5 w-5 text-blue-500" />Push Notifications</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        {!supported ? (
          <p className="text-sm text-gray-500">Push notifications are not supported in this browser.</p>
        ) : permission === 'denied' ? (
          <div className="p-4 rounded-lg bg-red-50 border border-red-100">
            <p className="text-sm text-red-700 font-medium">Notifications Blocked</p>
            <p className="text-xs text-red-500 mt-1">You have blocked notifications for this site. To enable, click the lock icon in your browser address bar and allow notifications.</p>
          </div>
        ) : (
          <>
            <div className="flex items-center justify-between p-4 rounded-lg bg-slate-50 border" data-testid="push-toggle">
              <div>
                <p className="text-sm font-semibold text-gray-900">Inquiry Alerts</p>
                <p className="text-xs text-gray-500 mt-0.5">Get instant push notifications when visitors submit product inquiries</p>
              </div>
              <Switch checked={isSubscribed} onCheckedChange={handleToggle} data-testid="push-switch" />
            </div>
            {isSubscribed && (
              <Button variant="outline" size="sm" onClick={handleTest} disabled={testing} className="gap-2" data-testid="push-test-btn">
                <Bell className="h-4 w-4" />{testing ? 'Sending...' : 'Send Test Notification'}
              </Button>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
}
